import gsap from 'gsap';

export default class Loading {
  constructor() {
    this.loading      = document.querySelector('.js-loading');
    this.loadingInner = document.querySelector('.js-loading-inner');
    this.logoFill     = document.querySelector('.js-loading-logo-fill');
    this.overlay      = document.querySelector('.js-loading-overlay');
    this.productWrap  = document.querySelector('.js-loading-product');
    this.packages     = document.querySelectorAll('.o-loading__package');
    this.products     = document.querySelectorAll('.o-loading__product');
    this.wrapper      = document.querySelector('.wrapper');
    this.body         = document.querySelector('body');
  }

  _showContentImmediately() {
    // loading要素を非表示
    this.loading?.remove();
    this.overlay?.remove();
    this.loading = null;
    this.overlay = null;
    // スクロールを復元
    this.body.style.position = 'static';
    this.body.style.overflow = 'hidden auto';
    
    // ロード完了のイベントを発火
    window.dispatchEvent(new Event('loadingComplete'));
  }

  init() {
    // スクロールを停止
    this.body.style.position = 'fixed';
    // パッケージの表示をランダムで決める（3パターン、クラス付与）
    const randomClass = ['p1','p2','p3'][Math.floor(Math.random()*3)];
    if(randomClass === 'p1'){
      this.productWrap.id = 'type-1';
    }else if(randomClass === 'p2'){
      this.productWrap.id = 'type-2';
    }else if(randomClass === 'p3'){
      this.productWrap.id = 'type-3';
    }
    
    this.tl = gsap.timeline();


    //ページロードを確認するフラグ
    this.pageIsLoaded = document.readyState === 'complete';
    window.addEventListener('load', () => {
      this.pageIsLoaded = true;

      if (this.tl.paused()) {
        this.tl.play();
      }
    });

    //GSAPタイムラインここから
    this.tl.to(this.logoFill, {
      height: '100%',
      ease: 'power3.in',
      duration: 2,
      onStart: () => this.body.classList.add(randomClass),
      onComplete: () => {
        if (!this.pageIsLoaded) {
          this.tl.pause();
        }
      }
    });

    this.packages.forEach(block => {
      this.tl.to(block, {
        transform: 'translateX(-50%) translateY(0)',
        ease: 'power2.out',
        duration: 0.3,
      }, '-=0.33');
    });

    this.products.forEach(block => {
      this.tl.to(block, {
        top: '-15%',
        transform: 'translateX(-50%) translateY(0)',
        ease: 'back.out(0.7)',
        duration: 0.2,
      }, '-=0.1');
    });

    this.tl.to(this.overlay, {
      transform: 'translateX(0)',
      ease: 'power2.inOut',
      duration: 1,
    });

    this.tl.to(this.loadingInner, {
      transform: 'scale(1.2)',
      ease: 'power2.inOut',
      duration: 1,
    }, '-=1');

    this.tl.to([this.overlay, this.loading], {
      transform: 'translateX(-100%)',
      ease: 'power3.inOut',
      duration: 1.5,
    });

    this.tl.from(this.wrapper, {
      scale: 1.1,
      ease: 'power2.inOut',
      duration: 0.8,
    }, '-=1');

    this.tl.set(this.wrapper, { clearProps: 'transform' });

    this.tl
    .add(() => {
      this.body.style.position = 'static';
      document.body.style.overflow = 'hidden auto';
      void document.body.offsetHeight;
      window.dispatchEvent(new Event('resize'));
    })
    .add(() => {
        this.loading?.remove();
        this.overlay?.remove();
        this.loading = null;
        this.overlay = null;
    });

    this.tl.add(() => {
      // ロード完了のイベントを発火
      window.dispatchEvent(new Event('loadingComplete'));
    });
    

    //GSAPタイムラインここまで
  }
}
